import { useState, useEffect } from "react";

import { apiRoot } from "../constants";

const useTags = () => {
  const [tags, setTags] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    fetch(`${apiRoot}/tags/`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setTags(json);
            setError(false);
            setLoading(false);
          });
        } else {
          setError(true);
          setTags([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setTags([]);
        setLoading(false);
      });
  }, []);

  return {
    tags,
    error,
    loading,
  };
};

export default useTags;
